import React, { Component } from 'react';
import axios from '../../axios';
import moment from 'moment';
import {NavLink} from 'react-router-dom';
import Alert from 'react-s-alert';
import qs from 'qs';
import XLSX from 'xlsx'

class DetailMapel extends Component {

    constructor(props) {
        super(props)
        this.state = {
            user_id : "",
            dataDetailMapel : [],
            isLoading : false,
        }
        this.exportFile = this.exportFile.bind(this);

    }

    loadDetailData() {

        const params = qs.stringify({
            pg : this.props.match.params.pg_id
        });

        console.log(params)
         
        axios({
            method: 'post',
            url: '/reportmapeldetail?' + params
        })
        .then((response) => {
            const result = response.data
            if (result.success === true) {                
                console.log(result)
                this.setState({
                    dataDetailMapel: result.data,
                    tglFilter: result.detail.pg_create_date,
                    kelasFilter: result.detail.kelas_nama,
                    mapelFilter: result.detail.mapel_nama,
                    mapelGuru: result.detail.user_nama,
                    isLoading: false 
                })
                console.log(this.state.kelasFilter)
            }
            else {
        
                Alert.error(result.text)
                this.setState({ isLoading: false })
            }      
        })
        .catch((error) => {
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Terjadi masalah internal !")
        })
    }

    exportFile() {
        let presensi = [["Nama Guru", this.state.mapelGuru ]]
        presensi.push(["Mata Pelajaran", this.state.mapelFilter ])
        presensi.push(["Kelas", this.state.kelasFilter ])
        presensi.push(["Periode", this.state.tglFilter ])
        presensi.push([" "])
        presensi.push(["<b>Nama Siswa</b>", "Tanggal", "Status", "Deskripsi"])
        this.state.dataDetailMapel.map(item => {
          presensi.push([item.nama_siswa,
                        moment(item.pgd_create_date).format("DD MMMM YYYY - h:m:s A"),
                        item.pgd_status,
                        item.pgd_note === null ? "-" : item.pgd_note
                    ])
        })
        const wb = XLSX.utils.book_new()
        const wsAll = XLSX.utils.aoa_to_sheet(presensi)
            XLSX.utils.book_append_sheet(wb, wsAll, "All Users")
            XLSX.writeFile(wb, "Rekap Presensi Guru Per Jadwal-"+ moment().format('DD-MMMM-YYYY') +".xlsx")
      }

    componentDidMount() {
        this.loadDetailData()
    }

    render() {
        return (
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">Detail Absensi Mata Pelajaran Per Kelas
                                <button className="btn btn-primary pull-right" onClick={this.exportFile}> Export Data </button>
                    </div>

                    <div className="card-block">
                        <div>
                            <div className="form-group row">
                                <label className="col-md-1 form-control-label">Guru</label>
                                <label className="col-md-10 form-control-label"> : <b>{this.state.mapelGuru}</b></label>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-1 form-control-label">Mata Pelajaran</label>
                                <label className="col-md-10 form-control-label"> : <b>{this.state.mapelFilter}</b></label>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-1 form-control-label">Kelas</label>
                                <label className="col-md-10 form-control-label"> : <b>{this.state.kelasFilter}</b></label>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-1 form-control-label">Periode</label>
                                <label className="col-md-10 form-control-label"> : <b>{moment(this.state.tglFilter).format("DD MMMM YYYY")}</b></label>
                            </div>                             
                        </div>
                    </div>

                   {
                       this.state.dataDetailMapel.length === 0 ? "Presensi tidak ditemukan" : (
                        <div className="card-block">
                            <table className="table table-striped animated fadeIn">
                                <thead>
                                    <tr>
                                        <td width="20">No</td>
                                        <td>Nama</td>
                                        <td>Tanggal</td>
                                        <td>Kehadiran</td>
                                        <td>Deskripsi</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.dataDetailMapel.map((item, i) => {
                                            return(
                                                <tr key={item.pgd_id}>
                                                    <td>{i + 1}</td>
                                                    <td>{item.nama_siswa}</td>
                                                    <td>{moment(item.pgd_create_date).format("DD MMMM YYYY - h:m:s A")}</td>
                                                    <td>{item.pgd_status}</td>
                                                    <td>{item.pgd_note === null ? "-" : item.pgd_note}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                       )
                   }
                </div>
            </div>
        );
    }
}

export default DetailMapel;


// WEBPACK FOOTER //
// ./src/views/ReportPresensi/DetailMapel.js